import { render, staticRenderFns } from "./WelfareMallStaffRights.vue?vue&type=template&id=27e2bc83&scoped=true"
import script from "./WelfareMallStaffRights.vue?vue&type=script&lang=js"
export * from "./WelfareMallStaffRights.vue?vue&type=script&lang=js"
import style0 from "./WelfareMallStaffRights.vue?vue&type=style&index=0&id=27e2bc83&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e2bc83",
  null
  
)

export default component.exports